module.exports = __webpack_public_path__ + "static/media/account_verify.b2ee6141.svg";